import React from 'react';
import {
  Box,
  Typography,
  ToggleButton,
  ToggleButtonGroup
} from '@mui/material';
import { useTheme } from '@emotion/react';
import { tokens } from '../theme';
import CartilageMap from './CartilageMap';
import ImageUploader from './ImageUploader';
import InteractiveImageMapper from './InteractiveImageMapper';

/**
 * ImageQuestion Component
 * Form builder için görsel soru tipi bileşeni
 * Kullanıcı görsele alanlar ekleyebilir ve her alana isim/değer verebilir
 */
const ImageQuestion = ({ 
  questionData = {}, 
  onQuestionDataChange = () => {},
  disabled = false 
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  // Question data destructuring
  const { imageUrl = '', areas = [], imageAnswerMode = 'select' } = questionData;

  // Görsel URL değiştirme
  const handleImageUrlChange = (url) => {
    onQuestionDataChange({
      ...questionData,
      imageUrl: url
    });
  };

  const handleModeChange = (_event, value) => {
    if (!value) return;
    onQuestionDataChange({
      ...questionData,
      imageAnswerMode: value
    });
  };

  return (
    <Box>
      {/* Görsel Yükleme */}
      <Box sx={{ mb: 3 }}>
        <ImageUploader
          imageUrl={imageUrl}
          onImageChange={handleImageUrlChange}
          disabled={disabled}
        />
      </Box>

      {/* İnteraktif Görsel Haritalama */}
      {imageUrl && (
        <Box sx={{ mb: 2 }}>
          <Typography
            variant="subtitle1"
            sx={{
              mb: 1,
              color: colors.greenAccent[400],
              fontWeight: 'bold'
            }}
          >
            Answer Mode
          </Typography>
          <ToggleButtonGroup
            exclusive
            value={imageAnswerMode}
            onChange={handleModeChange}
            size="small"
          >
            <ToggleButton value="select">Select Area</ToggleButton>
            <ToggleButton value="draw">Draw on Image</ToggleButton>
          </ToggleButtonGroup>
        </Box>
      )}

      {imageUrl && imageAnswerMode === 'select' && (
        <Box sx={{ mb: 3 }}>
          <Typography
            variant="subtitle1"
            sx={{
              mb: 2,
              color: colors.greenAccent[400],
              fontWeight: 'bold'
            }}
          >
            🗺️ Alanları Çizin ve Tanımlayın
          </Typography>
          <InteractiveImageMapper
            imageUrl={imageUrl}
            areas={areas}
            onAreasChange={(newAreas) => {
              onQuestionDataChange({
                ...questionData,
                areas: newAreas
              });
            }}
            disabled={disabled}
          />
        </Box>
      )}

      {/* Görsel Önizleme */}
      {imageUrl && imageAnswerMode === 'select' && areas.length > 0 && (
        <Box sx={{ mt: 3 }}>
          <Typography
            variant="subtitle1"
            sx={{
              mb: 2,
              color: colors.greenAccent[400],
              fontWeight: 'bold'
            }}
          >
            👁️ Önizleme (CartilageMap)
          </Typography>
          <CartilageMap
            imageUrl={imageUrl}
            areas={areas}
            disabled={true}
            showLabels={true}
          />
        </Box>
      )}

      {imageUrl && imageAnswerMode === 'draw' && (
        <Box sx={{ mt: 2, p: 1.5, backgroundColor: colors.blueAccent[900], borderRadius: 2 }}>
          <Typography variant="caption" sx={{ color: colors.blueAccent[300] }}>
            Users will answer this question by drawing on the uploaded image.
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default ImageQuestion;

